<template>
    <div class="container-fluid py-4">
      <!-- 기존 코드 -->
      <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">출석현황</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <select v-model="filters.department" @change="fetchGrades()" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;" required>
                    <option value="">부서 선택 *</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                  <select v-model="filters.grade" @change="fetchStudents(1)" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">반</option>
                    <option value="all">전체</option>
                    <option v-for="group in grades" :key="group.id" :value="group.id">
                      {{ group.name }}
                    </option>
                  </select>
                  <select v-model="filters.date" @change="fetchStudents(1)" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">날짜 선택</option>
                    <option v-for="date in attenddate" :key="date.no" :value="date.dday">
                      {{ date.dday }}
                    </option>
                  </select>
                  <input
                    v-model="filters.name"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="이름 검색"
                  />
                  <button class="btn btn-light text-success me-2 mt-2 mt-sm-0" @click="fetchStudents(1)">검색</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th>번호</th>
                      <th>사진</th>
                      <th>이름</th>
                      <th>반</th>
                      <th>생년월일</th>
                      <th>선생님</th>
                      <th>출결</th>
                      <th>출결일</th>
                    </tr>
                  </thead>
                  <tbody id="memberlist_table">
                    <tr v-if="attendanceRecords.length === 0">
                      <td colspan="8" class="text-center">조회된 자료가 없습니다</td>
                    </tr>
                    <tr v-for="(record, index) in attendanceRecords" :key="record.no">
                      <td class="text-center">
                        <p>{{ (index + 1) + ((currentPage - 1) * 10) }}</p>
                      </td>
                      <td class="text-center">
                        <img
                        :src="record.photo !== null && record.photo !== ''
                                ? `https://manna.dongan1718.com/upload/photo/${record.photo}` 
                                : record.photo2 !== null && record.photo2 !== ''
                                ? `https://manna.dongan1718.com/upload/photo/${record.photo2}` 
                                : require('@/assets/img/noimage.png')"                                
                        class="avatar me-3 border-radius-lg"
                        alt="photo"
                      />

                      </td>
                      <td class="text-center">
                        <p>{{ record.name }}</p>
                      </td>
                      <td class="text-center"><p>{{ record.classid }}</p></td>
                      <td class="text-center"><p>{{ record.birthday }}</p></td>
                      <td class="text-center"><p>{{ record.teachername }}</p></td>
                      <td class="text-center">
                        <p :style="{ color: record.attendyn === '결석' ? 'red' : '' }">{{ record.attendyn }}</p>
                      </td>
                      <td class="text-center"><p>{{ record.attenddate }}</p></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination d-flex justify-content-center mt-4">
                <div class="text-center mb-2" v-if="totalRows > 0">
                  <small class="text-muted">총 {{ totalRows }}개</small>
                </div>
                <nav aria-label="Page navigation" v-if="totalPages > 0">
                  <ul class="pagination">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchStudents(currentPage - 1)">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                      <a class="page-link" href="#" @click.prevent="fetchStudents(page)">{{ page }}</a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchStudents(currentPage + 1)">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>            
            </div>
          </div>
        </div>
      </div>
  
      <!-- Popup Modal -->
      <div v-if="showPopup">
        <member-detail
          :student="selectedStudent"
          @close="closePopup"
          @save="saveStudent"
        />
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import MemberDetail from "@/views/MemberDetail.vue";
  import apiservice from "../services/apiservice";
  
  export default {
    name: "tables",
    components: { MemberDetail },
    data() {
      return {
        students: [],
        currentPage: 1,
        totalPages: 1,
        totalRows: 0,
        filters: {
          classid: "",
          name: "",
          phone: "",
          school: "",
          grade: null,
          date: "",
          department: "",
          withdrawal: "exclude",
        },
        userData: "",
        showPopup: false,
        selectedStudent: {},
        attendanceRecords: [],
        attenddate: [], // 날짜 데이터를 저장할 배열
        gradecode: [],
        departments: [],
        grades: [],
      };
    },
    computed: {
      displayedPages() {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (this.totalPages <= maxVisiblePages) {
          // 전체 페이지가 최대 표시 페이지 수보다 작거나 같으면 모든 페이지 표시
          for (let i = 1; i <= this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          // 현재 페이지 주변의 페이지만 표시
          let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
          let endPage = startPage + maxVisiblePages - 1;
          
          if (endPage > this.totalPages) {
            endPage = this.totalPages;
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
          }
          
          for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
          }
        }
        
        return pages;
      },
      isSuperUser() {
        return this.$store.state.userData?.superuser === '1';
      }
    },
    methods: {
      async fetchDates() {
        try {
          const response = await axios.get("/api/attend/calendar");
          this.attenddate = response.data; // API에서 받은 날짜 데이터
          console.log("Fetched dates:", this.attenddate);
        } catch (error) {
          console.error("Failed to fetch dates:", error);
        }
      },      
      async fetchStudents(page = 1) {
        try {
          // 부서 선택 필수 검사 (슈퍼유저만 해당)
          if (this.isSuperUser && !this.filters.department) {
            alert("부서를 선택해주세요.");
            return;
          }
          
          // 날짜 선택 필수 검사
          if (!this.filters.date) {
            alert("날짜를 선택해주세요.");
            return;
          }

          // 페이지 번호 유효성 검사
          page = parseInt(page);
          if (isNaN(page) || page < 1) page = 1;
          
          // 필터 데이터 복사
          const filterParams = { ...this.filters };
          
          // department 값을 classid에도 설정
          filterParams.classid = filterParams.department;
          
          // "전체" 선택 시 grade 파라미터 처리
          if (filterParams.grade === 'all') {
            filterParams.grade = '';
            filterParams.allGrades = true;
          }
          
          console.log("Fetching students with params:", { page, ...filterParams });
          
          // axios.get 대신 apiservice.attendlist 사용
          const response = await apiservice.attendlist({
            page,
            ...filterParams
          });
          
          if (response.data && response.data.data) {
            this.attendanceRecords = response.data.data;
            this.currentPage = parseInt(response.data.currentPage || page);
            this.totalPages = parseInt(response.data.totalPages || 1);
            this.totalRows = parseInt(response.data.totalRows || 0);
            
            // 페이지 번호가 유효하지 않은 경우 처리
            if (this.totalPages < 1) this.totalPages = 1;
            if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;
            
            console.log("Fetched attendance records:", this.attendanceRecords);
          } else {
            console.error("Unexpected response format:", response);
            this.attendanceRecords = [];
          }
        } catch (error) {
          console.error("Failed to fetch students:", error);
          this.attendanceRecords = [];
        }
      },
      openPopup(student) {
        this.selectedStudent = { ...student };
        this.showPopup = true;
      },
      closePopup() {
        this.showPopup = false;
        this.selectedStudent = {};
      },
      async handleSave(updatedStudent) {
        try {
          await axios.post("/api/attend/update", updatedStudent);
          alert("수정 완료");
          this.closePopup();
          this.fetchStudents();
        } catch (error) {
          console.error("Error updating student:", error);
          alert("수정 중 오류 발생");
        }
      },
      async fetchGroups() {
        if (!this.filters.classid) return;
        try {
          const response = await axios.get("/api/students/grade", {
            params: { classid: this.filters.classid },
          });
          this.gradecode = response.data.data;
          console.log("Fetched gradecode:", this.gradecode);
        } catch (error) {
          console.error("Failed to fetch groups:", error);
        }
      },
      async fetchDepartments() {
        try {
          const response = await apiservice.getdeptlist();
          this.departments = response.data.data.map(department => ({
            id: department.code,
            name: department.codename
          }));
        } catch (error) {
          console.error("Failed to fetch department list:", error);
        }
      },
      async fetchGrades() {
        if (!this.filters.department) {
          this.grades = [];
          return;
        }
        
        // department 값을 classid에도 설정
        this.filters.classid = this.filters.department;
        
        try {
          const response = await apiservice.getclasslist({ classid: this.filters.department });
          this.grades = response.data.data.map(grade => ({
            id: grade.grade,
            name: grade.gradename
          }));
          
          // 반 목록을 가져온 후 자동으로 "전체" 선택
          this.filters.grade = "all";
          
          // 반 목록이 변경되면 학생 목록 다시 가져오기
          this.fetchStudents(1);
        } catch (error) {
          console.error("Failed to fetch grades:", error);
        }
      },
      async fetchSundays() {
        try {
          const response = await apiservice.getsunday();
          this.attenddate = response.data.data.map(date => ({
            no: date.no,
            dday: date.dday
          }));
        } catch (error) {
          console.error("Failed to fetch Sundays:", error);
        }
      },
    },
    mounted() {
      this.fetchDates(); // 날짜 데이터를 가져옴
      this.fetchGroups();
      this.fetchDepartments().then(() => {
        // 사용자 권한 확인 및 부서 고정 처리
        const userData = this.$store.state.userData;
        if (userData && userData.superuser !== '1') {
          // superuser가 1이 아닌 경우 classid 값으로 department.id 고정
          this.filters.department = userData.classid;
          // 부서 선택 후 반 목록 가져오기
          this.fetchGrades();
        }
      });
      this.fetchSundays();
    },
  };
  </script>
  
  <style scoped>
  .d-flex.align-items-center {
    align-items: center;
  }

  .searchInput {
  text-align: center;
  width: 150px;
  background-color: white !important;
  margin-bottom: 0;
}

  .btn {
    margin-bottom: 0;
  }
  
  .card-header, .card-body, .pagination {
    padding: 10px;
  }
  
  .pagination {
    margin-bottom: 0;
  }

  .page-link {
    color: #4CAF50;
  }

  .page-item.active .page-link {
    background-color: #4CAF50;
    border-color: #4CAF50;
  }
  
  /* 반응형 스타일 */
  @media (max-width: 768px) {
    .d-flex {
      flex-direction: column;
      align-items: stretch;
    }
    .form-select, .form-control {
      width: 100% !important;
      margin-bottom: 10px;
    }
    .searchInput {
      text-align: left;
    }
  }
  </style>